import { render } from "./SubMenu3.vue?vue&type=template&id=be948afa&scoped=true"
import script from "./SubMenu3.vue?vue&type=script&lang=js"
export * from "./SubMenu3.vue?vue&type=script&lang=js"

import "./SubMenu3.vue?vue&type=style&index=0&id=be948afa&scoped=true&lang=css"
import "./SubMenu3.vue?vue&type=style&index=1&id=be948afa&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be948afa"]])

export default __exports__